import APIClient from '../../../lib/api';

class PaymentService {
  async getAll(params = {}) {
    const defaultParams = {
      skip: 0,
      limit: 50,
    };
    
    const queryParams = { ...defaultParams, ...params };
    
    try {
      const response = await APIClient.payments.getAll(queryParams);
      return {
        success: true,
        data: response.data?.data || response.data || [],
        total: response.data?.total || response.data?.length || 0
      };
    } catch (error) {
      console.error('PaymentService.getAll Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης πληρωμών'
      };
    }
  }

  async getById(paymentId) {
    try {
      const response = await APIClient.payments.getById(paymentId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('PaymentService.getById Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης πληρωμής'
      };
    }
  }

  async create(paymentData) {
    try {
      const response = await APIClient.payments.create(paymentData);
      return {
        success: true,
        data: response.data,
        message: 'Η πληρωμή δημιουργήθηκε επιτυχώς'
      };
    } catch (error) {
      console.error('PaymentService.create Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας πληρωμής'
      };
    }
  }

  async update(paymentId, updateData) {
    try {
      const response = await APIClient.payments.update(paymentId, updateData);
      return {
        success: true,
        data: response.data,
        message: 'Η πληρωμή ενημερώθηκε επιτυχώς'
      };
    } catch (error) {
      console.error('PaymentService.update Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης πληρωμής'
      };
    }
  }

  async delete(paymentId) {
    try {
      await APIClient.payments.delete(paymentId);
      return {
        success: true,
        message: 'Η πληρωμή διαγράφηκε επιτυχώς'
      };
    } catch (error) {
      console.error('PaymentService.delete Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής πληρωμής'
      };
    }
  }

  async getByClient(clientId, params = {}) {
    try {
      const response = await APIClient.payments.getByClient(clientId, params);
      return {
        success: true,
        data: response.data?.data || response.data || [],
        total: response.data?.total || response.data?.length || 0
      };
    } catch (error) {
      console.error('PaymentService.getByClient Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης πληρωμών πελάτη'
      };
    }
  }

  async getClientSummary(clientId) {
    try {
      const response = await APIClient.payments.getClientSummary(clientId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('PaymentService.getClientSummary Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης σύνοψης πελάτη'
      };
    }
  }

  async getByInvoice(invoiceId, params = {}) {
    try {
      const response = await APIClient.payments.getByInvoice(invoiceId, params);
      return {
        success: true,
        data: response.data || [],
        total: response.data?.length || 0
      };
    } catch (error) {
      console.error('PaymentService.getByInvoice Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης πληρωμών τιμολογίου'
      };
    }
  }

  async getInvoiceSummary(invoiceId) {
    try {
      const response = await APIClient.payments.getInvoiceSummary(invoiceId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('PaymentService.getInvoiceSummary Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης σύνοψης τιμολογίου'
      };
    }
  }

  async getAllocations(paymentId) {
    try {
      const response = await APIClient.paymentAllocations.listByPayment(paymentId);
      return {
        success: true,
        data: response.data || []
      };
    } catch (error) {
      console.error('PaymentService.getAllocations Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης κατανομών πληρωμής'
      };
    }
  }

  async getAllocationsBatch(paymentIds) {
    try {
      if (!paymentIds || paymentIds.length === 0) {
        return {
          success: true,
          data: {}
        };
      }
      const response = await APIClient.paymentAllocations.listByPaymentsBatch(paymentIds);
      return {
        success: true,
        data: response.data || {}
      };
    } catch (error) {
      console.error('PaymentService.getAllocationsBatch Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης κατανομών πληρωμών',
        data: {}
      };
    }
  }

  async getStatistics(clientId = null, clientIsActive = null) {
    try {
      const params = {};
      if (clientId != null && clientId !== undefined && !Number.isNaN(Number(clientId))) {
        params.client_id = Number(clientId);
      }
      if (clientIsActive === true) {
        params.client_is_active = true;
      } else if (clientIsActive === false) {
        params.client_is_active = false;
      }
      const response = await APIClient.payments.getStatistics(params);
      return {
        success: true,
        data: response.data || {
          total_deposits: 0,
          total_services_cost: 0,
          total_paid: 0,
          balance: 0
        }
      };
    } catch (error) {
      console.error('PaymentService.getStatistics Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης στατιστικών',
        data: {
          total_deposits: 0,
          total_services_cost: 0,
          total_paid: 0,
          balance: 0
        }
      };
    }
  }

  /**
   * Πρόταση κατανομής (heuristic backend) — αντικαθιστά τις γραμμές φόρμας, όχι αποθήκευση χωρίς επιβεβαίωση.
   */
  async suggestAllocations({ clientId, amount, paymentDate, excludePaymentId = null }) {
    try {
      const params = {
        client_id: clientId,
        amount,
        payment_date: paymentDate,
      };
      if (excludePaymentId != null && excludePaymentId !== '') {
        params.exclude_payment_id = excludePaymentId;
      }
      const response = await APIClient.payments.suggestAllocations(params);
      return {
        success: true,
        allocations: response.data?.allocations || [],
        leftoverUnallocated: response.data?.leftover_unallocated ?? 0,
        strategy: response.data?.strategy,
      };
    } catch (error) {
      console.error('PaymentService.suggestAllocations Error:', error);
      const detail = error.response?.data?.detail;
      const msg =
        typeof detail === 'string'
          ? detail
          : Array.isArray(detail)
            ? detail.map((d) => d.msg || d).join('; ')
            : error.message || 'Σφάλμα πρότασης κατανομής';
      return { success: false, error: msg };
    }
  }

  validate(paymentData) {
    const errors = {};

    if (!paymentData.amount || paymentData.amount <= 0) {
      errors.amount = 'Το ποσό είναι υποχρεωτικό και πρέπει να είναι μεγαλύτερο από 0';
    }

    if (!paymentData.payment_method) {
      errors.payment_method = 'Ο τρόπος πληρωμής είναι υποχρεωτικός';
    }

    if (!paymentData.payment_date) {
      errors.payment_date = 'Η ημερομηνία πληρωμής είναι υποχρεωτική';
    }

    // Έλεγχος allocations αν υπάρχουν
    if (paymentData.allocations && paymentData.allocations.length > 0) {
      const totalAllocated = paymentData.allocations.reduce((sum, alloc) => sum + (parseFloat(alloc.allocated_amount) || 0), 0);
      const paymentAmount = parseFloat(paymentData.amount) || 0;
      
      if (totalAllocated > paymentAmount) {
        errors.allocations = 'Το συνολικό ποσό των κατανομών δεν μπορεί να ξεπερνά το ποσό της πληρωμής';
      }

      // Έλεγχος κάθε allocation
      paymentData.allocations.forEach((allocation, index) => {
        if (!allocation.service_id) {
          errors[`allocations[${index}].service_id`] = 'Η υπηρεσία είναι υποχρεωτική';
        }
        if (!allocation.allocated_amount || allocation.allocated_amount <= 0) {
          errors[`allocations[${index}].allocated_amount`] = 'Το ποσό είναι υποχρεωτικό και πρέπει να είναι μεγαλύτερο από 0';
        }
      });
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  // Utility methods
  formatAmount(amount) {
    return new Intl.NumberFormat('el-GR', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount || 0);
  }

  formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString('el-GR');
  }

  formatPaymentMethod(method) {
    const methodMap = {
      cash: 'Μετρητά',
      bank_transfer: 'Τραπεζική Κατάθεση',
      card: 'Κάρτα',
      check: 'Επιταγή',
      other: 'Άλλο'
    };
    return methodMap[method] || method;
  }

  // Helper method για φόρτωση υπηρεσιών για allocations
  async getClientServices(clientId) {
    try {
      const response = await APIClient.services.getClientServicesPaymentSummary(clientId);
      
      // The API returns [ServicePaymentSummary] directly
      const services = response.data || [];
      
      return {
        success: true,
        data: services
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης υπηρεσιών'
      };
    }
  }

  async downloadReceipt(paymentId) {
    try {
      const response = await APIClient.payments.downloadReceipt(paymentId);
      return {
        success: true,
        data: response.data,
        filename: response.headers['content-disposition']?.split('filename=')[1]?.replace(/"/g, '') || `Receipt_${paymentId}.pdf`
      };
    } catch (error) {
      console.error('PaymentService.downloadReceipt Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα λήψης απόδειξης'
      };
    }
  }
}

const paymentService = new PaymentService();
export default paymentService;
